import React from 'react';
import * as styles from './SettingsNavItem.module.scss';
import SVGIcon from '../components/SVGIcon';
import Link from '../utils/router/Link';

interface SettingsNavItemProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  to: string;
  onlyActiveOnIndex?: boolean;
}

const SettingsNavItem = ({
  children,
  icon,
  to,
  onlyActiveOnIndex,
}: SettingsNavItemProps) => (
  <Link
    to={to}
    className={styles.item}
    activeClassName={styles.active}
    onlyActiveOnIndex={onlyActiveOnIndex}
  >
    <div className={styles.icon}>
      {typeof icon === 'string' ? <SVGIcon size={16}>{icon}</SVGIcon> : icon}
    </div>
    {children}
  </Link>
);

export default SettingsNavItem;
